const RemoveHtmlTags = (text: string) => {

    if(!text){
        return ""
    }

    return text?.replace(/<[^>]*>?/gm, '');
}

export default RemoveHtmlTags